import {
  limitedReleaseByRegionConstants,
  createLimitedReleaseByRegionConstants,
  editLimitedReleaseByRegionConstants,
  addTargetLimitedReleaseByRegionConstants,
  removeTargetLimitedReleaseByRegionConstants,
  activateLimitedReleaseByRegionConstants,
  deactivateLimitedReleaseByRegionConstants,
  deleteLimitedReleaseByRegionConstants,
} from "../_redux-constants";

export function limitedReleasesRegionReducer(
  state = {
    limitedReleaseByRegionLoading: false,
    limitedReleaseByRegionData: null,
    limitedReleaseByRegionError: null,

    createLimitedReleaseByRegionLoading: false,
    createLimitedReleaseByRegionData: null,
    createLimitedReleaseByRegionError: null,

    editLimitedReleaseByRegionLoading: false,
    editLimitedReleaseByRegionData: null,
    editLimitedReleaseByRegionError: null,

    addTargetLimitedReleaseByRegionLoading: false,
    addTargetLimitedReleaseByRegionData: null,
    addTargetLimitedReleaseByRegionError: null,

    removeTargetLimitedReleaseByRegionLoading: false,
    removeTargetLimitedReleaseByRegionData: null,
    removeTargetLimitedReleaseByRegionError: null,

    activateLimitedReleaseByRegionLoading: false,
    activateLimitedReleaseByRegionData: null,
    activateLimitedReleaseByRegionError: null,

    deactivateLimitedReleaseByRegionLoading: false,
    deactivateLimitedReleaseByRegionData: null,
    deactivateLimitedReleaseByRegionError: null,

    deleteLimitedReleaseByRegionLoading: false,
    deleteLimitedReleaseByRegionData: null,
    deleteLimitedReleaseByRegionError: null,
  },
  action
) {
  switch (action.type) {
    case limitedReleaseByRegionConstants.LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        limitedReleaseByRegionLoading: true,
        limitedReleaseByRegionData: null,
        limitedReleaseByRegionError: null,
      });
    case limitedReleaseByRegionConstants.LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        limitedReleaseByRegionLoading: false,
        limitedReleaseByRegionData: action.data,
      });
    case limitedReleaseByRegionConstants.LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        limitedReleaseByRegionLoading: false,
        limitedReleaseByRegionData: null,
        limitedReleaseByRegionError: action.error,
      });
    case createLimitedReleaseByRegionConstants.CREATE_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        createLimitedReleaseByRegionLoading: true,
        createLimitedReleaseByRegionData: null,
        createLimitedReleaseByRegionError: null,
      });
    case createLimitedReleaseByRegionConstants.CREATE_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        createLimitedReleaseByRegionLoading: false,
        createLimitedReleaseByRegionData: action.data,
      });
    case createLimitedReleaseByRegionConstants.CREATE_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        createLimitedReleaseByRegionLoading: false,
        createLimitedReleaseByRegionData: null,
        createLimitedReleaseByRegionError: action.error,
      });
    case editLimitedReleaseByRegionConstants.EDIT_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        editLimitedReleaseByRegionLoading: true,
        editLimitedReleaseByRegionData: null,
        editLimitedReleaseByRegionError: null,
      });
    case editLimitedReleaseByRegionConstants.EDIT_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        editLimitedReleaseByRegionLoading: false,
        editLimitedReleaseByRegionData: action.data,
      });
    case editLimitedReleaseByRegionConstants.EDIT_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        editLimitedReleaseByRegionLoading: false,
        editLimitedReleaseByRegionData: null,
        editLimitedReleaseByRegionError: action.error,
      });
    case addTargetLimitedReleaseByRegionConstants.ADD_TARGET_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        addTargetLimitedReleaseByRegionLoading: true,
        addTargetLimitedReleaseByRegionData: null,
        addTargetLimitedReleaseByRegionError: null,
      });
    case addTargetLimitedReleaseByRegionConstants.ADD_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        addTargetLimitedReleaseByRegionLoading: false,
        addTargetLimitedReleaseByRegionData: action.data,
      });
    case addTargetLimitedReleaseByRegionConstants.ADD_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        addTargetLimitedReleaseByRegionLoading: false,
        addTargetLimitedReleaseByRegionData: null,
        addTargetLimitedReleaseByRegionError: action.error,
      });
    case removeTargetLimitedReleaseByRegionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseByRegionLoading: true,
        removeTargetLimitedReleaseByRegionData: null,
        removeTargetLimitedReleaseByRegionError: null,
      });
    case removeTargetLimitedReleaseByRegionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseByRegionLoading: false,
        removeTargetLimitedReleaseByRegionData: action.data,
      });
    case removeTargetLimitedReleaseByRegionConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseByRegionLoading: false,
        removeTargetLimitedReleaseByRegionData: null,
        removeTargetLimitedReleaseByRegionError: action.error,
      });
    case activateLimitedReleaseByRegionConstants.ACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        activateLimitedReleaseByRegionLoading: true,
        activateLimitedReleaseByRegionData: null,
        activateLimitedReleaseByRegionError: null,
      });
    case activateLimitedReleaseByRegionConstants.ACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        activateLimitedReleaseByRegionLoading: false,
        activateLimitedReleaseByRegionData: action.data,
      });
    case activateLimitedReleaseByRegionConstants.ACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        activateLimitedReleaseByRegionLoading: false,
        activateLimitedReleaseByRegionData: null,
        activateLimitedReleaseByRegionError: action.error,
      });
    case deactivateLimitedReleaseByRegionConstants.DEACTIVATE_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByRegionLoading: true,
        deactivateLimitedReleaseByRegionData: null,
        deactivateLimitedReleaseByRegionError: null,
      });
    case deactivateLimitedReleaseByRegionConstants.DEACTIVATE_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByRegionLoading: false,
        deactivateLimitedReleaseByRegionData: action.data,
      });
    case deactivateLimitedReleaseByRegionConstants.DEACTIVATE_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByRegionLoading: false,
        deactivateLimitedReleaseByRegionData: null,
        deactivateLimitedReleaseByRegionError: action.error,
      });
    case deleteLimitedReleaseByRegionConstants.DELETE_LIMITED_RELEASE_BY_REGION_LOADING:
      return Object.assign({}, state, {
        deleteLimitedReleaseByRegionLoading: true,
        deleteLimitedReleaseByRegionData: null,
        deleteLimitedReleaseByRegionError: null,
      });
    case deleteLimitedReleaseByRegionConstants.DELETE_LIMITED_RELEASE_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        deleteLimitedReleaseByRegionLoading: false,
        deleteLimitedReleaseByRegionData: action.data,
      });
    case deleteLimitedReleaseByRegionConstants.DELETE_LIMITED_RELEASE_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        deleteLimitedReleaseByRegionLoading: false,
        deleteLimitedReleaseByRegionData: null,
        deleteLimitedReleaseByRegionError: action.error,
      });
    default:
      return state;
  }
}
